import React, {Component} from 'react';

class BridalMakeupLearnMore extends Component {
    constructor(props) {
        super(props)
        this.activePopupHair = this.activePopupHair.bind(this);
    }

    activePopupHair() {
        this.props.handlePopupBridalMakeup(false)
    }

    render() {
        return (
            <div id="popup-hair" className="slickModal isActive"
                 style={{"transition-duration": "0.4s"}}>
                <div className="slickOverlay closeModal setSlickCookie"
                     style={{'background': 'rgba(0, 0, 0, 0.85098)', 'transition-duration': '0.4s'}}></div>
                <div className="slickWindow center animated" style={{
                    'width': '320px',
                    'height': '500px',
                    'box-shadow': 'rgba(0, 0, 0, 0.4) 0px 0px 20px 0px',
                    'background': 'rgb(255, 255, 255)',
                    'border-radius': '0px',
                    'margin': 'auto',
                    'padding': '0px',
                    'animation-duration': '0.4s',
                    'animation-delay': '0.2'
                }}>
                    <div className="slickCloseBtn close closeModal icon"
                         onClick={this.activePopupHair}
                    ></div>
                    <div className="wrap">
                        <div className="popup-icon"></div>
                        <h2>Bridal Makeup Services:</h2>
                        <div className="stylulist">
                            <strong>PRO and ELITE:</strong> "PRO" stylists have been freelancing for multiple years and are highly skilled in their craft. Our "ELITE" stylists are the top talent in the industry. They have extensive portfolios and have freelanced in the beauty industry for many years. "ELITE" stylists often times have an array of clients and are typically in high-demand.
                        </div>
                        <div className="stylulist">
                            <strong>Bridal Makeup Trial:</strong> Full face makeup application (lashes included).
                            <em>Duration: 1 Hour</em>
                        </div>
                        <div className="stylulist">
                            <strong>Bridal Makeup (Wedding day):</strong>  Bridal full face makeup application on wedding day (lashes included).
                            <em>Duration: 1 Hour</em>
                        </div>
                        <div className="stylulist">
                            <strong>Bridesmaids/Mother Makeup:</strong> Full face makeup application (lashes included).
                            <em>Duration: 1 Hour</em>
                        </div>
                        <div className="stylulist">
                            <strong>Airbrush Makeup:</strong> $25 (additional charge) Full makeup application plus airbrush application.
                            <em>Duration: 1 Hour</em>
                        </div> 
                    </div>
                    <div className="cta" style={{'display': 'none'}}>
                        <span className="closeModal">Close me</span>
                    </div>
                </div>
            </div>
        )
    }
}

export default BridalMakeupLearnMore;



/** WEBPACK FOOTER **
 ** ./src/components/BridalMakeupLearnMore.js
 **/